import { render } from "./index.vue?vue&type=template&id=3620aad3&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./css/index.scss?vue&type=style&index=0&id=3620aad3&lang=scss&scoped=true"

import exportComponent from "C:\\a_my\\myContents\\vue3组件库文档\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3620aad3"]])

export default __exports__